export class EnsureModuleLoadedOnceGuard {

    constructor(targetModule: any) {
        if (targetModule) {
            throw new Error(`${targetModule.constructor.name} has already loaded.\
        Import this module in AppModule only`);
        }
    }
}
